(() => {
  if (window.__tathagatFooterEditorialBooted) return;
  window.__tathagatFooterEditorialBooted = true;

  const POINTER_SHIFT = 16;
  const BASE_SIZE = 100;

  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

  const initialize = (footer) => {
    if (!footer || footer.dataset.footerEditorialInitialized === 'true') return;
    footer.dataset.footerEditorialInitialized = 'true';

    const lockup = footer.querySelector('[data-footer-lockup]');
    const text = lockup?.querySelector('.footer-lockup__text');
    const words = lockup ? [...lockup.querySelectorAll('.footer-lockup__word')] : [];
    const compactQuery = window.matchMedia('(max-width: 749px)');
    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;
    let observer;

    // Fit the lockup to the footer width: one line on desktop, one word per line on mobile.
    const fit = () => {
      if (!lockup || !text || !words.length) return;
      const styles = window.getComputedStyle(lockup);
      let available = lockup.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
      if (available <= 0) return;
      lockup.style.setProperty('--lockup-size', `${BASE_SIZE}px`);
      let measured;
      if (compactQuery.matches) {
        measured = Math.max(...words.map((word) => word.getBoundingClientRect().width)) + BASE_SIZE * 0.2;
      } else {
        available -= POINTER_SHIFT * 2;
        measured = text.getBoundingClientRect().width;
      }
      if (measured <= 0) return;
      lockup.style.setProperty('--lockup-size', `${(Math.floor((BASE_SIZE * available) / measured * 10) / 10).toFixed(1)}px`);
    };
    fit();
    const resizeObserver = 'ResizeObserver' in window && lockup ? new ResizeObserver(fit) : null;
    resizeObserver?.observe(lockup);
    window.addEventListener('resize', fit);
    document.fonts?.ready.then(fit);
    document.fonts?.addEventListener?.('loadingdone', fit);

    // Entry reveal: grid fade, navigation stagger, newsletter, lockup mask, legal row.
    if ('IntersectionObserver' in window) {
      footer.classList.add('footer-ready');
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            footer.classList.add('is-in');
            observer.disconnect();
          }
        });
      }, { threshold: 0.1 });
      observer.observe(footer);
    }

    // Desktop pointer: the lockup drifts horizontally within its reserved margin.
    const onPointerMove = (event) => {
      if (!hoverQuery.matches || compactQuery.matches || reduceQuery.matches || !lockup) return;
      const bounds = footer.getBoundingClientRect();
      const x = clamp((event.clientX - bounds.left) / Math.max(bounds.width, 1) - 0.5, -0.5, 0.5) * 2;
      lockup.style.setProperty('--lockup-x', `${(-x * POINTER_SHIFT).toFixed(2)}px`);
    };
    const onPointerLeave = () => lockup?.style.setProperty('--lockup-x', '0px');
    footer.addEventListener('pointermove', onPointerMove);
    footer.addEventListener('pointerleave', onPointerLeave);

    // Mobile: slow scroll-linked reveal progress for the lockup.
    const updateScroll = () => {
      frame = 0;
      if (!lockup) return;
      const viewport = window.innerHeight || 1;
      const bounds = footer.getBoundingClientRect();
      // 0 when the footer enters the viewport, 1 when it is fully scrolled into view (the end of the page).
      const progress = clamp((viewport - bounds.top) / Math.max(bounds.height, 1), 0, 1);
      footer.style.setProperty('--footer-p', progress.toFixed(3));
    };
    const requestScroll = () => {
      if (!frame) frame = window.requestAnimationFrame(updateScroll);
    };
    updateScroll();
    window.addEventListener('scroll', requestScroll, { passive: true });
    window.addEventListener('resize', requestScroll);

    const cleanup = (event) => {
      if (event.target !== footer.closest('.shopify-section')) return;
      if (frame) window.cancelAnimationFrame(frame);
      observer?.disconnect();
      resizeObserver?.disconnect();
      footer.removeEventListener('pointermove', onPointerMove);
      footer.removeEventListener('pointerleave', onPointerLeave);
      window.removeEventListener('resize', fit);
      window.removeEventListener('scroll', requestScroll);
      window.removeEventListener('resize', requestScroll);
      document.fonts?.removeEventListener?.('loadingdone', fit);
      footer.classList.remove('footer-ready', 'is-in');
      footer.dataset.footerEditorialInitialized = 'false';
      document.removeEventListener('shopify:section:unload', cleanup);
    };
    document.addEventListener('shopify:section:unload', cleanup);
  };

  const boot = () => initialize(document.querySelector('[data-footer-editorial]'));
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
